import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { ExitToAppRounded } from '@mui/icons-material';
import { Container } from '@mui/material';
import { t } from 'i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header, { NavItemProps } from '../pages/layout/header/Header';
import { ReactComponent as ProfileIcon } from '../assets/icons/05-profile.svg';
import { ReactComponent as CaseManager } from '../assets/icons/14-case-manager.svg';
import { ReactComponent as Monitoring } from '../assets/icons/03-monitoring.svg';
import { ReactComponent as Screening } from '../assets/icons/01-screaning.svg';
import { ReactComponent as Admin } from '../assets/icons/11-admine.svg';
import { ReactComponent as StatisticsIcon } from '../assets/icons/07-control-center.svg';
import HeaderIcon from '../pages/layout/header/HeaderIcon';
import { createContext, useEffect, useState } from 'react';
import HeaderIconBox from '../pages/layout/header/HeaderIconBox';
import DynamicBreadcrumbs from '../pages/layout/breadcrumbs/Breadcrumbs';

interface BreadcrumbsTitleContextProps {
  customerName: string;
  applicationName: string;
  customDopFileName: string;
  walletName: string;
  setApplicationName: (value: string) => void;
  setCustomerName: (value: string) => void;
  setCustomDopFileName: (value: string) => void;
  setWalletName: (value: string) => void;
}

export const BreadcrumbsTitleContext =
  createContext<BreadcrumbsTitleContextProps>({
    customerName: '',
    applicationName: '',
    customDopFileName: '',
    walletName: '',
    setApplicationName: () => {},
    setCustomerName: () => {},
    setCustomDopFileName: () => {},
    setWalletName: () => {},
  });
export default function AppWrapper() {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuthenticator((context) => [context.user]);
  const [isCustomerListSelected, setCustomerListSelected] = useState(false);
  const [isSubtagsSelected, setSubtagsSelected] = useState(false);
  const [isMonitoringSelected, setMonitoringSelected] = useState(false);
  const [isStatisticsSelected, setIsStatisticsSelected] = useState(false);
  const [isDailyControlCustomerSelected, setDailyControlCustomerSelected] =
    useState(false);
  const [customDopsSelected, setCustomDopsSelected] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [customDopFileName, setCustomDopFileName] = useState('');
  const [applicationName, setApplicationName] = useState('');
  const [walletName, setWalletName] = useState('');

  useEffect(() => {
    setCustomerListSelected(
      location.pathname.includes('customers') &&
        !location.pathname.includes('daily_control')
    );
    setSubtagsSelected(location.pathname.includes('subtags'));
    setCustomDopsSelected(location.pathname.includes('custom_dops'));
    setMonitoringSelected(location.pathname.includes('monitoring'));
    setIsStatisticsSelected(location.pathname.includes('stats'));
    setDailyControlCustomerSelected(
      location.pathname.includes('daily_control')
    );
  }, [location.pathname]);

  const menu: NavItemProps[] = [
    {
      navtitle: (
        <HeaderIconBox
          isSelected={isDailyControlCustomerSelected}
          label={'header.daily_control'}
        />
      ),
      icon: (
        <HeaderIcon
          isSelected={isDailyControlCustomerSelected}
          iconComponent={Admin}
        />
      ),
      action: () => {
        navigate('/daily_control');
      },
    },
    {
      navtitle: (
        <HeaderIconBox
          isSelected={isCustomerListSelected}
          label={'header.customer_manager'}
        />
      ),
      icon: (
        <HeaderIcon
          isSelected={isCustomerListSelected}
          iconComponent={CaseManager}
        />
      ),
      action: () => {
        navigate('api_customers');
      },
    },
    {
      navtitle: (
        <HeaderIconBox
          isSelected={isSubtagsSelected}
          label={'header.subtags'}
        />
      ),
      icon: (
        <HeaderIcon isSelected={isSubtagsSelected} iconComponent={Monitoring} />
      ),
      action: () => {
        navigate('/subtags');
      },
    },
    {
      navtitle: (
        <HeaderIconBox
          isSelected={customDopsSelected}
          label={'header.custom_dops'}
        />
      ),
      icon: (
        <HeaderIcon isSelected={customDopsSelected} iconComponent={Screening} />
      ),
      action: () => {
        navigate('/custom_dops');
      },
    },
    {
      navtitle: (
        <HeaderIconBox
          isSelected={isMonitoringSelected}
          label={'header.monitoring'}
        />
      ),
      icon: (
        <HeaderIcon isSelected={isMonitoringSelected} iconComponent={Monitoring} />
      ),
      action: () => {
        navigate('/monitoring');
      },
    },
    {
      navtitle: (
        <HeaderIconBox
          isSelected={isStatisticsSelected}
          label={'header.entity_statistics'}
        />
      ),
      icon: (
        <HeaderIcon isSelected={isStatisticsSelected} iconComponent={StatisticsIcon} />
      ),
      action: () => {
        navigate('/stats');
      },
    },
    {
      navtitle: <HeaderIconBox label={'header.profile'} />,
      icon: <HeaderIcon iconComponent={ProfileIcon} />,
      submenu: [
        {
          navtitle: t('header.logout'),
          icon: <ExitToAppRounded />,
          action: () => {
            signOut();
          },
        },
      ],
    },
  ];

  return (
    <Authenticator>
      <BreadcrumbsTitleContext.Provider
        value={{
          customerName,
          applicationName,
          customDopFileName,
          walletName,
          setApplicationName,
          setCustomerName,
          setCustomDopFileName,
          setWalletName,
        }}
      >
        <Container maxWidth="xl" sx={{ paddingBottom: { xs: '2rem', md: '4rem' } }}>
          <Header menu={menu} />
          <DynamicBreadcrumbs />
          <Outlet />
        </Container>
      </BreadcrumbsTitleContext.Provider>
    </Authenticator>
  );
}
